'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.get = get;
exports.set = set;
exports.entries = entries;
exports.hydrate = hydrate;
exports.clear = clear;

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var cache = new Map();

function get(property, value) {
  return cache.get(property + value);
}

function set(property, value, className) {
  if (process.env.NODE_ENV !== 'production') {
    var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (valueType !== 'boolean' && valueType !== 'number' && valueType !== 'string') {
      var encodedValue = JSON.stringify(value);
      throw new TypeError("\uD83D\uDCE6 ui-box: invalid cache value \u201C" + encodedValue + "\u201D. Only booleans, numbers and strings are supported.");
    }
  }

  cache.set(property + value, className);
}

function entries() {
  return [].concat(_toConsumableArray(cache));
}

function hydrate(newEntries) {
  cache = new Map([].concat(_toConsumableArray(cache), _toConsumableArray(newEntries)));
}

function clear() {
  cache.clear();
}